import { render, staticRenderFns } from "./Beneficio.vue?vue&type=template&id=109848a4"
import script from "./Beneficio.vue?vue&type=script&lang=js"
export * from "./Beneficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports